module.exports = __webpack_public_path__ + "img/img4.09801439.png";